import { createClient } from '@supabase/supabase-js';

/* La "publishable key" (antes "anon key") es pública por diseño: va en el
   bundle del navegador sin problema. Lo que protege los datos es la
   seguridad a nivel de fila (RLS) del esquema, no que esta clave sea
   secreta — por eso va directa aquí en vez de por variables de entorno,
   que solo añadirían un paso más al desplegar sin ganar nada. */
export const supabase = createClient(
  'https://nxcreihkxydjbukoeknj.supabase.co',
  'sb_publishable_Zzrn1pK6EQYV9urnY1-uJQ_3jo2Rt0G',
);
